export default __webpack_public_path__ + "static/bodySectionBg-4c82e141680f20d09c194047532acf47.png";